import { type FC } from 'react';
import { UnorderedList, type ListProps } from '@chakra-ui/react';

export interface UiUnorderedListProps extends ListProps {}

export const UiUnorderedList: FC<UiUnorderedListProps> = ({ children, ...props }) => {
  return <UnorderedList {...props}>{children}</UnorderedList>;
};
